import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const CookiesPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="cookies-section padding-container">
      <div className="page-wrapper">
        <div className="cookies-policy">

          {/* Header Section */}
          <div className="cookies-top" data-aos="fade-up">
            <div className="last-updated" data-aos="fade-up">
            </div>
            <p>
              This Cookies Policy explains how <strong>VisionBird Technologies</strong> uses cookies on our website.
            </p>
          </div>

          {/* What Are Cookies */}
          <div className="cookies-definition" data-aos="fade-up">
            <h1>What Are <span className="orange-text">Cookies?</span></h1>
            <p>
              Cookies are small text files stored on your device to enhance your browsing experience. 
              They do not store sensitive data.
            </p>
          </div>

          {/* Types of Cookies */}
          <div className="cookies-types" data-aos="fade-up">
            <h1>Types of <span className="orange-text">Cookies We Use</span></h1>
            
            <div className="cookie-type-item" data-aos="fade-up">
            <ul className="orange-text"> <li> <h2>Essential Cookies</h2></li></ul>
              <p>Required for website functionality.</p>
            </div>

            <div className="cookie-type-item" data-aos="fade-up">
            <ul className="orange-text"> <li> <h2>Analytics Cookies</h2></li></ul>
              <p>Used for understanding user behavior (e.g., Google Analytics).</p>
            </div>

            <div className="cookie-type-item" data-aos="fade-up">
            <ul className="orange-text"> <li> <h2>Functionality Cookies</h2></li></ul>
              <p>Remember your preferences and settings.</p>
            </div>

            <div className="cookie-type-item" data-aos="fade-up">
            <ul className="orange-text"> <li> <h2>Performance Cookies</h2></li></ul>
              <p>Improve load speeds and page performance.</p>
            </div>

            <div className="cookie-type-item" data-aos="fade-up">
            <ul className="orange-text"> <li> <h2>Third-Party Cookies</h2></li></ul>
              <p>From trusted service providers only.</p>
            </div>

            <div className="cookie-note" data-aos="fade-up">
              <p>
                <strong>Note:</strong> We <strong>do not</strong> use advertising cookies unless stated.
              </p>
            </div>
          </div>

          {/* Why We Use Cookies */}
          <div className="cookies-purpose" data-aos="fade-up">
            <h1>Why We <span className="orange-text">Use Cookies?</span></h1>
            <p>To:</p>
            <ul>
              <li>Improve website performance</li>
              <li>Analyze visitor behavior</li>
              <li>Remember preferences</li>
              <li>Enhance user experience</li>
              <li>Support job application and contact forms</li>
              <br />
            </ul>
            <p>We <strong>do NOT</strong> use cookies to:</p>
            <ul>
              <li>Identify applicants personally</li>
              <li>Track sensitive information</li>
              <li>Evaluate job/internship eligibility</li>
            </ul>
          </div>

          {/* Cookies and Recruitment */}
          <div className="cookies-recruitment" data-aos="fade-up">
            <h1>Cookies and <span className="orange-text">Recruitment Activities</span></h1>
            <p>For job/internship applicants:</p>
            <ul>
              <li>Cookies may track form submissions</li>
              <li>Cookies do NOT influence application decisions</li>
              <li>Cookies do NOT store personal applicant data</li>
            </ul>
            <p>This prevents future legal claims of "automated rejection."</p>
          </div>

          {/* Managing Cookies */}
          <div className="cookies-management" data-aos="fade-up">
            <h1>Managing <span className="orange-text">Cookies</span></h1>
            <p>
              You may disable cookies through your browser.
              Some features may stop working.
            </p>
          </div>

          {/* Consent */}
          <div className="cookies-consent" data-aos="fade-up">
            <h1 className="orange-text">Consent</h1>
            <p>By using our site, you consent to the use of cookies where applicable.</p>
          </div>

          {/* Changes to Policy */}
          <div className="cookies-changes" data-aos="fade-up">
            <h1>Changes to <span className="orange-text">This Policy</span></h1>
            <p>We may update this policy periodically.</p>
          </div>

          {/* Contact Section */}
          <div 
            className="cookies-contact" 
            data-aos="fade-up" 
            style={{ marginBottom: "30px" }}
          >
            <h1 className="orange-text">Contact</h1>
            <p>For questions:</p>
            <p>
              <strong>VisionBird Technologies</strong><br />
              Email: <strong>info@visionbird.com</strong>
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;